import { API } from '@/config';

export default {
  async getRechargesSettings() {
    const rechargesAppSettings = (await API.get('/getRechargesSettings')).data.data;
    return rechargesAppSettings;
  },

  async getRechargesPaymentLink(params = {}) {
    const paymentLink = (await API.post('/getRechargesLinkPayments', { ...params })).data.data;
    return paymentLink;
  },

  closeApp() {
    window.parent.postMessage({
      command: 'closeApp',
      data: null,
    }, '*');
  },

  redirectToPay(redirectUrl) {
    window.parent.postMessage({
      command: 'redirectToPay',
      data: {
        redirectUrl,
      },
    }, '*');
  },
};
